module.exports = __webpack_public_path__ + "static/media/BTC.a310acd2.svg";